import { Component, input, output } from '@angular/core';
import { PlayerProfile } from '@core/saves/player-group-manager.service';
import { PortalButtonComponent } from '../portal-button/portal-button.component';
import { PortalPanelComponent } from '../portal-panel/portal-panel.component';
import { PortalProfileComponent } from '../portal-profile/portal-profile.component';

@Component({
  selector: 'app-portal-class-profiles',
  imports: [PortalButtonComponent, PortalPanelComponent, PortalProfileComponent],
  templateUrl: './portal-class-profiles.component.html',
  styleUrl: './portal-class-profiles.component.css',
})
export class PortalClassProfilesComponent {
  className = input('Klas van pieter');
  profiles = input<PlayerProfile[]>([]);
  clickedProfile = output<PlayerProfile>();
  clickedSwitchClass = output();
}
